import React, { forwardRef, useCallback, useEffect, useState } from 'react';

/**
 * HTML5 video wrapper. Defaults match the elokuva / movie event view (controls on, not muted).
 * For background / kiosk use: controls={false}, muted, autoPlay, loop.
 */
const Player = forwardRef(function Player(
  {
    src,
    poster,
    subtitles,
    controls = true,
    fullscreenOnlyControls = false,
    showCoverPlayOverlay = false,
    muted = false,
    autoPlay = false,
    loop = false,
    playsInline = true,
    wrapClassName = 'Elokuva-player-wrap',
    videoClassName = 'Elokuva-video',
    preload = 'auto',
    ariaHidden,
  },
  ref,
) {
  const [coverOverlayDismissed, setCoverOverlayDismissed] = useState(false);

  useEffect(() => {
    setCoverOverlayDismissed(false);
  }, [src, poster, showCoverPlayOverlay]);

  const handleCoverOverlayDismiss = useCallback(() => {
    if (!showCoverPlayOverlay || !poster || coverOverlayDismissed) return;
    setCoverOverlayDismissed(true);
  }, [coverOverlayDismissed, poster, showCoverPlayOverlay]);

  const resolvedVideoClassName = fullscreenOnlyControls
    ? `${videoClassName} Player-video--fullscreen-only`
    : videoClassName;
  return (
    <div className={wrapClassName} {...(ariaHidden ? { 'aria-hidden': true } : {})}>
      <video
        ref={ref}
        className={resolvedVideoClassName}
        src={src}
        {...(poster ? { poster } : {})}
        muted={muted}
        defaultMuted={muted}
        controls={controls}
        controlsList={fullscreenOnlyControls ? 'nodownload noplaybackrate noremoteplayback' : undefined}
        disablePictureInPicture={fullscreenOnlyControls}
        autoPlay={autoPlay}
        loop={loop}
        playsInline={playsInline}
        preload={preload}
        onClick={handleCoverOverlayDismiss}
        onPlay={handleCoverOverlayDismiss}
      >
        {subtitles ? (
          <track kind="subtitles" src={subtitles} srcLang="en" label="Tekstitys" default />
        ) : null}
      </video>
      {showCoverPlayOverlay && poster ? (
        <div
          className={`Player-cover-play-overlay${
            coverOverlayDismissed ? ' Player-cover-play-overlay--dismissed' : ''
          }`}
          aria-hidden
        >
          <div className="Player-cover-play-overlay-circle">
            <img
              src={`${process.env.PUBLIC_URL || ''}/pulina.png`}
              alt=""
              className="Player-cover-play-overlay-logo"
            />
            <div className="Player-cover-play-overlay-play-icon" />
          </div>
        </div>
      ) : null}
    </div>
  );
});

Player.displayName = 'Player';

export default Player;
